(() => {
  if (window.CasEnKasDeliverySchedule) return;

  const COUNTRY_NL = 'NL';
  const COUNTRY_BE = 'BE';
  const NETHERLANDS_SLOTS = ['08:00 - 14:00', '09:00 - 17:00', '12:00 - 18:00', '15:00 - 22:00'];
  const BELGIUM_DAY = '08:00 - 18:00';
  const BELGIUM_EVENING = '14:00 - 22:00';
  const CAL_WEEKDAYS = ['ma', 'di', 'wo', 'do', 'vr', 'za', 'zo'];
  const formatter = new Intl.DateTimeFormat('nl-NL', {
    day: 'numeric',
    month: 'short',
    weekday: 'short',
  });

  function amsterdamNow() {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Amsterdam',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(new Date()).reduce((values, part) => {
      if (part.type !== 'literal') values[part.type] = part.value;
      return values;
    }, {});

    return new Date(parts.year, Number(parts.month) - 1, parts.day, parts.hour, parts.minute);
  }

  function cloneDate(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  function addDays(date, days) {
    const result = cloneDate(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function sameDate(first, second) {
    return first.getFullYear() === second.getFullYear()
      && first.getMonth() === second.getMonth()
      && first.getDate() === second.getDate();
  }

  function dateValue(date) {
    return [
      String(date.getDate()).padStart(2, '0'),
      String(date.getMonth() + 1).padStart(2, '0'),
      date.getFullYear(),
    ].join('-');
  }

  function parseDateValue(value) {
    const match = String(value || '').match(/^(\d{2})-(\d{2})-(\d{2}|\d{4})$/);
    if (!match) return null;

    const year = match[3].length === 2 ? Number(`20${match[3]}`) : Number(match[3]);
    const month = Number(match[2]) - 1;
    const day = Number(match[1]);
    const date = new Date(year, month, day);
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day ? date : null;
  }

  function firstNetherlandsDate(now) {
    const today = cloneDate(now);
    const day = today.getDay();
    const beforeCutoff = now.getHours() < 14;

    if (day === 0) return addDays(today, 2);
    if (day === 6) return addDays(today, 3);
    if (day === 5) return addDays(today, beforeCutoff ? 1 : 4);
    return addDays(today, beforeCutoff ? 1 : 2);
  }

  function belgiumDeadline(deliveryDate) {
    const deadline = cloneDate(deliveryDate);
    const day = deadline.getDay();
    deadline.setDate(deadline.getDate() - (day === 1 ? 3 : 1));
    deadline.setHours(14, 0, 0, 0);
    return deadline;
  }

  function availableDates(country, now) {
    const firstDate = country === COUNTRY_NL ? firstNetherlandsDate(now) : addDays(now, 1);
    const dates = [];

    for (let offset = 0; offset < 80 && dates.length < 32; offset += 1) {
      const candidate = addDays(firstDate, offset);
      const day = candidate.getDay();

      if (country === COUNTRY_NL) {
        if (day !== 0) dates.push(candidate);
      } else if ([1, 3, 4].includes(day) && now < belgiumDeadline(candidate)) {
        dates.push(candidate);
      }
    }

    return dates;
  }

  function slotsFor(country, date) {
    if (country === COUNTRY_NL) return NETHERLANDS_SLOTS;
    return date.getDay() === 4 ? [BELGIUM_DAY, BELGIUM_EVENING] : [BELGIUM_DAY];
  }

  function selectedCountry(container) {
    const input = container.querySelector('[data-delivery-country]:checked');
    return input && input.value === 'België' ? COUNTRY_BE : COUNTRY_NL;
  }

  function initialize(container) {
    if (container.dataset.deliveryScheduleReady === 'true') return;
    container.dataset.deliveryScheduleReady = 'true';

    const dateInput = container.querySelector('[data-delivery-date]');
    const slotInput = container.querySelector('[data-delivery-slot]');
    const calGrid = container.querySelector('[data-delivery-cal-grid]');
    const calMonthEl = container.querySelector('[data-delivery-cal-month]');
    const calPrevBtn = container.querySelector('[data-delivery-cal-prev]');
    const calNextBtn = container.querySelector('[data-delivery-cal-next]');
    const slotHolder = container.querySelector('[data-delivery-slots]');
    const availability = container.querySelector('[data-delivery-availability]');
    const error = container.querySelector('[data-delivery-error]');

    let selectedDate = null;
    let selectedSlot = '';
    let calViewYear = null;
    let calViewMonth = null;

    // Restore a previously saved cart date/slot only if still valid — never auto-select
    {
      const now = amsterdamNow();
      const country = selectedCountry(container);
      const savedDate = parseDateValue(container.dataset.initialDate || dateInput.value);
      const savedSlot = container.dataset.initialSlot || slotInput.value;
      if (savedDate) {
        const match = availableDates(country, now).find((d) => sameDate(d, savedDate));
        if (match) {
          selectedDate = match;
          if (savedSlot && slotsFor(country, match).includes(savedSlot)) selectedSlot = savedSlot;
        }
      }
    }

    function clearError() {
      error.hidden = true;
      error.textContent = '';
    }

    function showError(message) {
      error.hidden = false;
      error.textContent = message;
    }

    function renderSlots() {
      slotHolder.innerHTML = '';
      if (!selectedDate) {
        const placeholder = document.createElement('p');
        placeholder.className = 'delivery-schedule__slots-placeholder';
        placeholder.textContent = 'Kies eerst een bezorgdatum';
        slotHolder.append(placeholder);
        slotInput.value = '';
        return;
      }
      const country = selectedCountry(container);
      const slots = slotsFor(country, selectedDate);
      if (!slots.includes(selectedSlot)) selectedSlot = '';

      slots.forEach((slot) => {
        const btn = document.createElement('button');
        btn.className = 'delivery-schedule__slot' + (slot === selectedSlot ? ' is-selected' : '');
        btn.type = 'button';
        btn.textContent = slot;
        btn.setAttribute('aria-pressed', String(slot === selectedSlot));
        btn.addEventListener('click', () => {
          selectedSlot = slot;
          slotInput.value = slot;
          renderSlots();
          clearError();
        });
        slotHolder.append(btn);
      });
      slotInput.value = selectedSlot;
    }

    function renderCalendar() {
      const now = amsterdamNow();
      const country = selectedCountry(container);
      const dates = availableDates(country, now);
      const availableSet = new Set(dates.map((d) => dateValue(d)));

      // Initialise view to the selected date's month, or the first available month
      if (calViewYear === null || calViewMonth === null) {
        const ref = selectedDate || (dates.length > 0 ? dates[0] : now);
        calViewYear = ref.getFullYear();
        calViewMonth = ref.getMonth();
      }

      // Month heading
      const label = new Intl.DateTimeFormat('nl-NL', { month: 'long', year: 'numeric' })
        .format(new Date(calViewYear, calViewMonth, 1));
      calMonthEl.textContent = label.charAt(0).toUpperCase() + label.slice(1);

      // Disable prev when already at the current month
      calPrevBtn.disabled = calViewYear < now.getFullYear()
        || (calViewYear === now.getFullYear() && calViewMonth <= now.getMonth());
      // Disable next when already at the last available month
      const lastDate = dates.length > 0 ? dates[dates.length - 1] : now;
      calNextBtn.disabled = calViewYear > lastDate.getFullYear()
        || (calViewYear === lastDate.getFullYear() && calViewMonth >= lastDate.getMonth());

      calGrid.innerHTML = '';

      // Weekday header row (Mo → Su)
      CAL_WEEKDAYS.forEach((wd) => {
        const cell = document.createElement('span');
        cell.className = 'delivery-schedule__cal-weekday';
        cell.setAttribute('aria-hidden', 'true');
        cell.textContent = wd;
        calGrid.append(cell);
      });

      // Leading empty cells so day 1 falls on the right weekday column
      let startOffset = new Date(calViewYear, calViewMonth, 1).getDay() - 1;
      if (startOffset < 0) startOffset = 6;
      for (let i = 0; i < startOffset; i++) {
        const cell = document.createElement('span');
        cell.className = 'delivery-schedule__cal-day delivery-schedule__cal-day--empty';
        cell.setAttribute('aria-hidden', 'true');
        calGrid.append(cell);
      }

      // Day buttons
      const daysInMonth = new Date(calViewYear, calViewMonth + 1, 0).getDate();
      for (let d = 1; d <= daysInMonth; d++) {
        const thisDate = new Date(calViewYear, calViewMonth, d);
        const val = dateValue(thisDate);
        const isAvailable = availableSet.has(val);
        const isSelected = selectedDate !== null && sameDate(thisDate, selectedDate);

        const btn = document.createElement('button');
        btn.className = 'delivery-schedule__cal-day' + (isSelected ? ' is-selected' : '');
        btn.type = 'button';
        btn.textContent = String(d);
        btn.setAttribute('aria-label', formatter.format(thisDate));
        btn.setAttribute('aria-pressed', String(isSelected));
        btn.disabled = !isAvailable;

        if (isAvailable) {
          btn.addEventListener('click', () => {
            selectedDate = thisDate;
            dateInput.value = val;
            renderCalendar();
            renderSlots();
            clearError();
          });
        }
        calGrid.append(btn);
      }

      dateInput.value = selectedDate ? dateValue(selectedDate) : '';
      availability.textContent = country === COUNTRY_NL
        ? 'Bestel voor 14:00 voor de eerstvolgende bezorgdag'
        : 'Bezorging op maandag, woensdag en donderdag';
    }

    calPrevBtn.addEventListener('click', () => {
      calViewMonth -= 1;
      if (calViewMonth < 0) { calViewMonth = 11; calViewYear -= 1; }
      renderCalendar();
    });

    calNextBtn.addEventListener('click', () => {
      calViewMonth += 1;
      if (calViewMonth > 11) { calViewMonth = 0; calViewYear += 1; }
      renderCalendar();
    });

    container.querySelectorAll('[data-delivery-country]').forEach((input) => {
      input.addEventListener('change', () => {
        selectedDate = null;
        selectedSlot = '';
        calViewYear = null;
        calViewMonth = null;
        renderCalendar();
        renderSlots();
        clearError();
      });
    });

    const form = container.closest('form');
    if (form) {
      form.addEventListener('submit', (event) => {
        const now = amsterdamNow();
        const country = selectedCountry(container);
        const dates = availableDates(country, now);
        const dateOk = selectedDate !== null && dates.some((d) => sameDate(d, selectedDate));
        const slotOk = dateOk && slotsFor(country, selectedDate).includes(selectedSlot);

        if (!dateOk) {
          event.preventDefault();
          event.stopImmediatePropagation();
          showError('Kies een bezorgdatum om door te gaan.');
          container.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else if (!slotOk) {
          event.preventDefault();
          event.stopImmediatePropagation();
          showError('Kies een tijdvak om door te gaan.');
          container.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, true);
    }

    renderCalendar();
    renderSlots();
  }

  function initializeAll(root = document) {
    if (root.matches && root.matches('[data-delivery-schedule]')) initialize(root);
    root.querySelectorAll('[data-delivery-schedule]').forEach(initialize);
  }

  window.CasEnKasDeliverySchedule = { initializeAll };
  document.addEventListener('DOMContentLoaded', () => initializeAll());
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));

  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) initializeAll(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
